import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_VabeneIngredientTypeList = _resolveComponent("VabeneIngredientTypeList");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('pages.ingredientTypeList')
        }, null, 8, ["PageTitle"]),
        _createVNode(_component_VabeneIngredientTypeList)
    ], 64));
}
